var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import moment from "moment";
import CalendarPopupDesk from "../../../shared-library/components/Calendar/CalendarPopupDesk";
import { getDateInFormat, getFinancialYear } from "@domains/utils/reportDates";
import { useRef } from "react";
import useOutsideClick from "../../../shared-library/utils/useOutsideClick";
var DateCalendar = function (_a) {
    var setShowWeekFlag = _a.setShowWeekFlag, setFinalFilterState = _a.setFinalFilterState, weeklyFirst = _a.weeklyFirst, todaysDate = _a.todaysDate, ToDatemax = _a.ToDatemax, fromDate = _a.fromDate, toDate = _a.toDate, isSkip = _a.isSkip, isMinDate = _a.isMinDate, lastQuarter = _a.lastQuarter, lastQuarterYear = _a.lastQuarterYear, monthlyFirst = _a.monthlyFirst, setShowMonthFlag = _a.setShowMonthFlag, resetShowMonth = _a.resetShowMonth, resetShowWeek = _a.resetShowWeek, dateChangeFilterData = _a.dateChangeFilterData, skipForFinalYear = _a.skipForFinalYear, setEndOfMonth = _a.setEndOfMonth, parentClassName = _a.parentClassName;
    var _b = __read(React.useState(fromDate
        ? getFinancialYear(new Date(fromDate))
        : getFinancialYear(new Date())), 2), finYear = _b[0], setFinYear = _b[1];
    var _c = __read(React.useState(false), 2), openCalendar = _c[0], setOpenCalendar = _c[1];
    var _d = __read(React.useState(finYear + 1), 2), nextFinYear = _d[0], setNextFinYear = _d[1];
    var _e = __read(React.useState(fromDate ? new Date(fromDate) : null), 2), startDate = _e[0], setStartDate = _e[1];
    var _f = __read(React.useState(toDate ? new Date(toDate) : null), 2), endDate = _f[0], setEndDate = _f[1];
    var _g = __read(React.useState(weeklyFirst), 2), showWeek = _g[0], setShowWeek = _g[1];
    var _h = __read(React.useState(monthlyFirst), 2), showMonth = _h[0], setShowMonth = _h[1];
    React.useEffect(function () {
        setShowWeekFlag && setShowWeekFlag(showWeek);
    }, [showWeek]);
    React.useEffect(function () {
        setShowMonthFlag && setShowMonthFlag(showMonth);
    }, [showMonth]);
    React.useEffect(function () {
        if (resetShowMonth) {
            setShowMonth(resetShowMonth);
        }
    }, [resetShowMonth]);
    React.useEffect(function () {
        if (resetShowWeek) {
            setShowWeek(resetShowWeek);
        }
    }, [resetShowWeek]);
    useEffect(function () {
        if (!isSkip)
            setFinalFilterState(function (filter) {
                var newfilter = __assign(__assign({}, filter), { fromDate: moment(startDate).format("YYYY/MM/DD"), toDate: moment(endDate).format("YYYY/MM/DD") });
                return newfilter;
            });
    }, [startDate, endDate, isSkip]);
    useEffect(function () {
        if (resetShowMonth) {
            setStartDate(new Date(moment().startOf("month").format("YYYY-MM-DD")));
            setEndDate(new Date(moment().endOf("month").format("YYYY-MM-DD")));
        }
        else if (resetShowWeek) {
            console.log("resetShowWeek", resetShowWeek);
            setFinYear(getFinancialYear(moment().startOf("isoWeek").toDate()));
            setNextFinYear(getFinancialYear(moment().startOf("isoWeek").toDate()) + 1);
            setStartDate(new Date(moment().startOf("isoWeek").toDate()));
            setEndDate(new Date(moment().endOf("isoWeek").toDate()));
        }
        else if (fromDate && toDate) {
            setFinYear(function () {
                return getFinancialYear(new Date(fromDate));
            });
            setNextFinYear(function () {
                return getFinancialYear(new Date(fromDate)) + 1;
            });
            setStartDate(function () {
                return new Date(fromDate);
            });
            setEndDate(function () {
                return new Date(toDate);
            });
        }
        else {
            setStartDate(new Date(finYear, 3, 1));
            setEndDate(new Date(finYear + 1, 2, 31));
        }
    }, [
        fromDate,
        toDate,
        lastQuarter,
        lastQuarterYear,
        resetShowMonth,
        resetShowWeek,
    ]);
    var showLabel = function (week, month) {
        if (week)
            return (React.createElement(React.Fragment, null,
                "This Week (",
                getDateInFormat(startDate, "D-MMM-YY"),
                " -",
                " ",
                getDateInFormat(endDate, "D-MMM-YY"),
                ")"));
        else if (month)
            return (React.createElement(React.Fragment, null,
                "This Month (",
                getDateInFormat(startDate, "D-MMM-YY"),
                " -",
                " ",
                getDateInFormat(endDate, "D-MMM-YY"),
                ")"));
        else
            return (React.createElement(React.Fragment, null,
                "FY ",
                finYear,
                "-",
                nextFinYear.toString().substring(2),
                React.createElement("span", { className: "DMSansNormal_20_400" },
                    "\u00A0(",
                    moment(startDate).format("D-MMM-YY"),
                    "\u00A0 to ",
                    moment(endDate).format("D-MMM-YY"),
                    ")")));
    };
    var calendarRef = useRef();
    useOutsideClick(calendarRef, function () { return setOpenCalendar(false); });
    return (React.createElement("div", { className: "sales-calendar ".concat(parentClassName !== null && parentClassName !== void 0 ? parentClassName : "") },
        React.createElement("div", { className: "d-flex calendar-block align-items-center" },
            React.createElement("label", { className: "txt_blackOne1 DMSansMedium_20_500" }, showLabel(showWeek, showMonth)),
            React.createElement("i", { className: "edel-icon-calendar2 txt-midnight-blue" }),
            React.createElement("div", { ref: calendarRef },
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Change", onClick: function () { return setOpenCalendar(!openCalendar); } }),
                React.createElement(CalendarPopupDesk, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, startDate: startDate, endDate: endDate, finYear: finYear, setStartDate: setStartDate, setEndDate: setEndDate, setFinYear: setFinYear, customTime: true, setNextFinYear: setNextFinYear, setShowWeek: setShowWeek, setShowMonth: setShowMonth, todaysDate: todaysDate, ToDatemax: ToDatemax, isMinDate: isMinDate, lastQuarter: lastQuarter, lastQuarterYear: lastQuarterYear, skipForFinalYear: skipForFinalYear, dateChangeFilterData: function (startDate, endDate, showMonth, showWeek) {
                        dateChangeFilterData(startDate, endDate, showMonth, showWeek);
                    }, setEndOfMonth: setEndOfMonth, skipForQuarter: true })))));
};
export default DateCalendar;
